(function ($) {
    if (!window.Opensoft){
        Opensoft = {};
    }

    $.fn.tm_flexsliderExtended = function(){
        return this.each(function () {
            var _this = $(this),
                _images = _this.find('.images-slider'),
                _description = _this.find('.description-slider'),
                _className = 'flexsliderExtended',

                build = function(_this, _images, _description, _className) {
                    _className += _this.index();
                    _description.attr('id', _className);

                    var idForSlide = '#'+_className;

                    _description.flexslider({
                        animation: "slide",
                        animationLoop: true,
                        startAt: 0,
                        useCSS: false,
                        controlNav: false,
                        directionNav: false,
                        keyboard: false,
                        before: function(slider){
                            _images.flexslider(slider.animatingTo);
                        }
                    });

                    _images.flexslider({
                        animation: "fade",
                        animationLoop: true,
                        startAt: 0,
                        useCSS: false,
                        controlNav: true,
                        directionNav: false,
                        keyboard: false,
                        sync: idForSlide
                    });

                };

            build(_this, _images, _description, _className);
        });
    };

    var app = {
        exists: function(x) {
            if ($(x).length > 0) { return true; }
        },
        competitions_minHeight: function() {
            $('.competitions').each(function(){
                $(this).find('.last-competition').removeAttr('style');

                if( $(this).find('.last-competition').css('float') != 'none') {
                    var heights = $(this).find('.last-competition').map(function (){
                            return $(this).height();
                        }).get(),
                        maxHeight = Math.max.apply(null, heights);

                    $(this).find('.last-competition').css({ 'min-height':maxHeight+'px' });
                }
            });
        },
        init: function() {
            if(app.exists('.header-menu')) {
                Opensoft.mobileMenu.init();
            }

            if(app.exists('.competitions')) {
                app.competitions_minHeight();

                $(window).resize(function(){
                    app.competitions_minHeight();
                });
            }

            if(app.exists('.next-contest')) {
                $('.next-contest').tm_flexsliderExtended();
            }
        }
    };

    Opensoft.mobileMenu = function () {
        var menu,
            header,
            wrapper,
            scrollCont,
            scrollVal = 0,
            menuOffset = 0,
            open = 0;

        function addToggleBtns() {
            scrollCont.find('> ul > li').each(function(){
                if($(this).find('ul').length > 0) {
                    $(this).addClass('toggleMargin');
                    $(this).find('> a').append('<div class="toggleBtn"><span></span></div>');
                }
            });

            scrollCont.find('.toggleBtn').on('tap',function(evt){
                evt.preventDefault();
                $(this).toggleClass('active');
                $(this).parent().parent().find('.mega-menu').slideToggle(200);
            });
        }

        function fixedDektop() {
            if (menu && menu.length > 0) {
                menuOffset = menu.offset().top;
            }

            $(window).bind('scroll.menufixedDesktop',function(){
                if($(this).scrollTop() >= menuOffset) {
                    menu.addClass('fixed');
                    header.css({ 'margin-bottom':'40px' });
                } else {
                    menu.removeClass('fixed');
                    header.css({ 'margin-bottom':'0' });
                }
            });

            $(window).trigger('.menufixedDesktop');
        }

        function destroyFixedDektop() {
            $(window).unbind('.menufixedDesktop');
            menu.removeClass('fixed');
        }

        return {
            removes: function() {
                menu.addClass('menu-desktop');
                $('#mobileMenuBtn').remove();
                wrapper.removeAttr('style');
                header.removeAttr('style');
                header.find('.mega-menu').removeAttr('style');
                menu.removeAttr('style');
                menu.find('li').removeClass('toggleMargin');

                $('body').removeClass('disable-scroll');

                if(app.exists('.mobile-toggle-submenu')) {
                    $('.toggleBtn').remove();
                }

                open = 0;
            },
            creates: function() {
                menu.removeClass('menu-desktop');
                header.append('<div id="mobileMenuBtn"><span class="mmline"></span><span class="mmline ml2"></span><span class="mmline ml3"></span></div>');

                if(app.exists('.mobile-toggle-submenu')) {
                    addToggleBtns();
                }

                $('#mobileMenuBtn').click(function() {
                    if(!open) {
                        menu.animate({right:'0px'},400);
                        wrapper.animate({left:'-260px'},400);
                        if(header.css('position') === 'fixed') {
                            header.animate({left:'-260px'},400);
                        }

                        scrollVal = $('body').scrollTop();

                        if(scrollVal === 0) {
                            scrollVal = $('html').scrollTop();
                        }

                        $('body').css('top', -(scrollVal) + 'px').addClass('disable-scroll');

                        open = 1;
                    } else {
                        wrapper.animate({left:'0px'},400);

                        if(header.css('position') === 'fixed') {
                            header.animate({left:'-0px'},400);
                        }

                        menu.animate({right:'-260px'},400,function(){
                            $('body').removeClass('disable-scroll').removeAttr('style');
                            $('html,body').scrollTop(scrollVal);
                        });

                        open = 0;
                    }

                    $(this).toggleClass('active');
                });
            },
            init: function() {
                menu = $('.header-menu');
                header = $('.header');
                wrapper = $('#wrapper');
                scrollCont = $('.header .menu-scroll');

                if (menu.length > 0) {
                    menu.addClass('menu-desktop');

                    if(menu.css('position') != 'fixed') {
                        fixedDektop();
                    }
                }

                if(menu.css('position') != 'fixed') {
                    fixedDektop();
                }

                if (typeof enquire !== 'undefined') {
                    enquire.register('screen and (max-width:1000px)', {
                        match: function() {
                            Opensoft.mobileMenu.creates();
                            destroyFixedDektop();
                        },
                        unmatch: function() {
                            Opensoft.mobileMenu.removes();
                            fixedDektop();
                        }
                    });
                }
            }
        };
    }();

    $(function(){
        app.init();
    });
}(jQuery));